export default "__VITE_ASSET__DvnfbFpt__"